// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"OW-z","sponsoredTooltipWrapper":"PW-z","sponsoredTooltip":"QW-z","newCard":"RW-z"};